const urls = {
  index: "/zones",
} as const;

export default urls;
